import { type FC, memo } from "react";

import AddCartToWishlistPopupFlow from "~/features/AddCartToWishlist/AddCartToWishlistPopupFlow";
import { LinkButton } from "../../../../../common/components/Link";
import { useBooleanState } from "../../../../../common/hooks/useBooleanState";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { selectCartProductAmount, selectLinearProductAmount } from "~/features/cart/cart/redux/selectors/cartSelectors";
import { userIsPublic } from "~/domains/user/utils/roles";
import { CART_PAGE } from "~/utils/url/staticUrls";
import { getRedirectToRegisterPage, redirectToUrl } from "~/utils/url/urlUtils";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import BookmarkIcon from "@mui/icons-material/Bookmark";

interface AddCartToWishlistBtnProps {
  className?: string;
  isB2BCart?: boolean;
}

const AddCartToWishlistBtn: FC<AddCartToWishlistBtnProps> = ({ className, isB2BCart = false }) => {
  const { t } = useTranslation();

  const autoOpenParameter = "openACTW";
  const autoOpen = new URLSearchParams(window.location.search).get(autoOpenParameter) === "true";
  const cartPageWithParam = `${CART_PAGE}?${autoOpenParameter}=true`;

  const { val: modalOpen, setTrue: open, setFalse: close } = useBooleanState(autoOpen);

  const productAmount = useSelector(selectCartProductAmount);
  const linearProductAmount = useSelector(selectLinearProductAmount);
  const cartContainsLinearProduct = linearProductAmount > 0;
  const allProductsInCartAreLinear = linearProductAmount === productAmount;

  const cb = () => {
    if (userIsPublic()) {
      redirectToUrl(getRedirectToRegisterPage({ targetPage: cartPageWithParam, openLogin: true }));
    } else {
      open();
    }
  };

  return (
    <>
      <LinkButton
        onClick={cb}
        disabled={allProductsInCartAreLinear}
        data-test-id={"btn-copy-cart-to-wishlist"}
        iconBefore={isB2BCart ? <BookmarkBorderOutlinedIcon /> : <BookmarkIcon  />}
        className={className}
      >
        {t("cartPage.btn.copyToWishlist")}
      </LinkButton>
      {modalOpen && (
        <AddCartToWishlistPopupFlow
          onClose={close}
          info={cartContainsLinearProduct ? t("whishList.popup.info") : undefined}
        />
      )}
    </>
  );
};

export default memo(AddCartToWishlistBtn);
